import React, { useState } from "react";
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    InputAdornment,
    TextField,
    Typography,
} from "@mui/material";
import Visibility    from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export default function PortalCredentialsModal({ open, onClose, onSubmit, loading, error }) {
    const [username,     setUsername]     = useState("");
    const [password,     setPassword]     = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = () => {
        if (!username.trim() || !password.trim()) return;
        onSubmit(username.trim(), password);
    };

    const handleClose = () => {
        setUsername("");
        setPassword("");
        setShowPassword(false);
        onClose();
    };

    return (
        <Dialog open={open} onClose={!loading ? handleClose : undefined} maxWidth="xs" fullWidth>
            <DialogTitle>Portal Login</DialogTitle>

            <DialogContent sx={{ pt: "12px !important" }}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Enter your FIP portal credentials to begin processing.
                </Typography>

                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {error}
                    </Alert>
                )}

                <TextField
                    label="Username"
                    value={username}
                    onChange={e => setUsername(e.target.value)}
                    fullWidth
                    size="small"
                    disabled={loading}
                    sx={{ mb: 2 }}
                    autoFocus
                />

                <TextField
                    label="Password"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    fullWidth
                    size="small"
                    disabled={loading}
                    onKeyDown={e => { if (e.key === "Enter") handleSubmit(); }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    size="small"
                                    onClick={() => setShowPassword(s => !s)}
                                    edge="end"
                                    tabIndex={-1}
                                >
                                    {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose} variant="outlined" color="primary" disabled={loading}>
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="primary"
                    disabled={loading || !username.trim() || !password.trim()}
                >
                    {loading ? "Submitting…" : "Submit"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
